import { render, staticRenderFns } from "./ParapharmacyProductSelected.vue?vue&type=template&id=39ebf794"
import script from "./ParapharmacyProductSelected.vue?vue&type=script&lang=js"
export * from "./ParapharmacyProductSelected.vue?vue&type=script&lang=js"
import style0 from "./ParapharmacyProductSelected.vue?vue&type=style&index=0&id=39ebf794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports